module.exports = __webpack_public_path__ + "img/google_sync_migrate.c99cb334.png";